import { array } from "fp-ts"
import { pipe } from "fp-ts/function"

type BreadcrumbPath = {
  name: string
  slugPath: string[]
}

export const toBreadcrumbPath = <T extends { namePath: string[]; slugPath: string[] }>(
  t: T
): BreadcrumbPath[] =>
  pipe(t.slugPath, array.reverse, array.duplicate, array.reverse, array.map(array.reverse), (a1) =>
    array.zipWith(a1, t.namePath, (slugPath, name) => ({ name, slugPath }))
  )
